import { useState } from "react";
import { toast } from "sonner";
import { Copy, Check } from "lucide-react";
import { CA } from "../config";

export const copyCa = async () => {
    try {
        await navigator.clipboard.writeText(CA);
    } catch {
        const ta = document.createElement("textarea");
        ta.value = CA;
        ta.style.position = "fixed";
        ta.style.opacity = "0";
        document.body.appendChild(ta);
        ta.select();
        document.execCommand("copy");
        document.body.removeChild(ta);
    }
    toast.success("CA COPIED 🕊️");
};

export default function CopyButton({ testId = "copy-ca-button", label = "COPY CA", className = "btn-ghost" }) {
    const [copied, setCopied] = useState(false);
    return (
        <button
            type="button"
            data-testid={testId}
            className={className}
            onClick={async () => {
                await copyCa();
                setCopied(true);
                setTimeout(() => setCopied(false), 2000);
            }}
        >
            {copied ? <Check className="h-4 w-4 text-green-400" /> : <Copy className="h-4 w-4" />}
            {copied ? "COPIED" : label}
        </button>
    );
}
